import type { GridApiPremium, GridColDef, GridRenderCellParams } from "@mui/x-data-grid-premium";
import type { RefObject } from "react";
import type { DimensionField, TabularRow } from "../../../../../../../../../api/types/svTypes.ts";
import { ItemDataType } from "../../../../../../../../../api/types/svTypes.ts";
import { buildColumnBase } from "../base-column/buildColumnBase.ts";
import { buildTabularCell } from "../buildTabularCell.tsx";
import { renderColumnHeader } from "../tabularGridDataProvider.tsx";
import { getCellFromRow } from "./buildDimensionColumnHelper.ts";

export const buildDimensionColumn = (
  api: RefObject<GridApiPremium | null>,
  field: DimensionField,
  getFieldTitle: (guid: string) => string
): GridColDef => {
  return {
    ...buildColumnBase(
      {
        guid: field.config.guid,
        headerName: field.config.customLabel || field.config.systemLabel || field.meta.caption || "",
        align: field.meta.type === ItemDataType.Numeric ? "right" : "left",
        groupable: field.meta.type === ItemDataType.General || field.meta.type === ItemDataType.Date,
        hideAggregation: false,
      },
      api
    ),
    renderHeader: () => renderColumnHeader(getFieldTitle(field.config.guid), false),
    renderCell: (params: GridRenderCellParams<TabularRow>) => {
      const cell = getCellFromRow(params?.row, params?.field);
      return buildTabularCell({
        cellType: "dimension",
        cell,
        formattedValue: cell?.formattedValue,
        typographyProps: { color: "text.primary" },
      });
    },
  };
};
